/* Connect SendWrite to the Backend */
import { connect } from 'react-redux';
import SendWrite from './SendWrite';
import CAC from './Constants';
import * as sendwriteactions from './Actions';


const mapStateToProps = state => ({
    currentsenduser: state.currentsenduser,
    postData: state.postData,
    messageStatus: state.messageStatus,
    sendlist: state.sendlist,
    userlist: state.userlist
});

const mapDispatchToProps = dispatch => ({
     pwPostSend: (senduser, post) => {
        dispatch(sendwriteactions.pwPostSend(senduser, post)).then((response) => {
            if(!response.error){
                dispatch(sendwriteactions.pwPostSendSuccess(response.value.data))
                dispatch(sendwriteactions.pwGetSends(senduser)).then((response) => {
                    !response.error ? 
                    dispatch(sendwriteactions.pwGetSendsSuccess(response.value.data)) :
                    dispatch(sendwriteactions.pwGetSendsFailure(response.value.data))
                   });
                dispatch(sendwriteactions.pwGetUserlist()).then((response) => {
                    !response.error ? 
                    dispatch(sendwriteactions.pwGetUserlistSuccess(response.value.data)) :
                    dispatch(sendwriteactions.pwGetUserlistFailure(response.value.data))
                });
                dispatch(sendwriteactions.pwGetSendlist()).then((response) => {
                    !response.error ? 
                    dispatch(sendwriteactions.pwGetSendlistSuccess(response.value.data)) :
                    dispatch(sendwriteactions.pwGetSendlistFailure(response.value.data))
                });
                dispatch(sendwriteactions.pwUpdateMessageStatus(''))

            }
            else{
                dispatch(sendwriteactions.pwPostSendFailure(response.value.data))
                dispatch(sendwriteactions.pwUpdateMessageStatus(response.value.data))
            }
        });
     },
     pwUpdatePostData: (currentpost) => {
        dispatch({
        type: `${CAC.POSTUPDATE}`,
        payload: currentpost
      });
    }
});



const SendWriteConnectContainer =  connect(mapStateToProps, mapDispatchToProps)(SendWrite);
export default SendWriteConnectContainer;


// WEBPACK FOOTER //
// ./src/SendWriteConnectContainer.js